module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJQcm9wZXJ0eSAxPSYjMjMzOyYjMTg3OyYjMTMyOyYjMjMxOyYjMTM3OyYjMTQwOyI+DQo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNOCAwSDRDMi44OTU0MyAwIDIgMC44OTU0MyAyIDJWMTBDMiAxMS4xMDQ2IDIuODk1NDMgMTIgNCAxMkg4QzkuMTA0NTcgMTIgMTAgMTEuMTA0NiAxMCAxMFYyQzEwIDAuODk1NDMgOS4xMDQ1NyAwIDggMFoiIGZpbGw9IiNGRkM4NjkiLz4NCjwvZz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details/event/18.svg
// module id = O++u
// module chunks = 0